import React, { useCallback, useState } from "react";
import { Cpu, FileText } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/Tabs";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../components/ui/AlertDialog";
import { ProvidersTab } from "./ProvidersTab";
import { PromptTab } from "./PromptTab";

type TabValue = "providers" | "prompt";

export const AdminAiConfigPage: React.FC = () => {
  const [tab, setTab] = useState<TabValue>("providers");
  const [providersDirty, setProvidersDirty] = useState(false);
  const [pendingTab, setPendingTab] = useState<TabValue | null>(null);

  const handleTabChange = (value: string) => {
    const next = value as TabValue;
    if (tab === "providers" && providersDirty && next !== "providers") {
      setPendingTab(next);
      return;
    }
    setTab(next);
  };

  const onDirtyChange = useCallback(
    (dirty: boolean) => setProvidersDirty(dirty),
    []
  );

  return (
    <section className="space-y-8">
      <header>
        <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground font-medium mb-2">
          Inteligência artificial
        </p>
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          Configuração
        </h1>
        <p className="mt-1.5 text-sm text-muted-foreground">
          Os providers definem quem gera o changelog e em que ordem. O prompt
          define como o texto sai escrito.
        </p>
      </header>

      <Tabs value={tab} onValueChange={handleTabChange} className="space-y-6">
        <TabsList>
          <TabsTrigger value="providers">
            <Cpu className="w-3.5 h-3.5" aria-hidden="true" />
            Providers
          </TabsTrigger>
          <TabsTrigger value="prompt">
            <FileText className="w-3.5 h-3.5" aria-hidden="true" />
            Prompt
          </TabsTrigger>
        </TabsList>

        <TabsContent value="providers" className="mt-0">
          <ProvidersTab onDirtyChange={onDirtyChange} />
        </TabsContent>

        <TabsContent value="prompt" className="mt-0">
          <PromptTab />
        </TabsContent>
      </Tabs>

      <AlertDialog
        open={pendingTab !== null}
        onOpenChange={(open) => {
          if (!open) setPendingTab(null);
        }}
      >
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Sair sem salvar os providers?</AlertDialogTitle>
            <AlertDialogDescription>
              Há alterações de provider que ainda não foram salvas. Trocar de aba
              agora descarta o que você editou.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Continuar editando</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                if (pendingTab) setTab(pendingTab);
                setPendingTab(null);
              }}
            >
              Descartar e trocar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </section>
  );
};
